import { render, staticRenderFns } from "./CustomCard.vue?vue&type=template&id=ac746056&scoped=true"
import script from "./CustomCard.vue?vue&type=script&lang=js"
export * from "./CustomCard.vue?vue&type=script&lang=js"
import style0 from "./CustomCard.vue?vue&type=style&index=0&id=ac746056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac746056",
  null
  
)

export default component.exports